import { AxiosRequestConfig } from 'axios';
import * as SGCaptcha from '@byted/bric_verify_sec_sdk_build/captcha/sg';
import * as VACaptcha from '@byted/bric_verify_sec_sdk_build/captcha/va';
import * as INCaptcha from '@byted/bric_verify_sec_sdk_build/captcha/in';
import * as TTPCaptcha from '@byted/bric_verify_sec_sdk_build/captcha/ttp';
import { TypeInitProps, TypeSliderView, TypeRequest } from '../types/index';
import { objectToString, stringToObject } from './index';

let repeatRequest: TypeRequest, fp: string;

const defaultOptions = {
  commonOptions: {
    aid: 0,
    iid: '0',
    did: '0',
  },
  captchaOptions: {
    sideSlide: 'disabled',
    lang: 'zh',
    showMode: 'mask',
    region: 'sg',
    app_name: '',
  },
};
const captchaMap: { [key: string]: any } = {
  // cn: CNCaptcha,
  sg: SGCaptcha,
  va: VACaptcha,
  gcp: INCaptcha,
  in: INCaptcha,
  ttp: TTPCaptcha,
};
let TTGCaptcha: any;

const initCaptcha = (props: TypeInitProps) => {
  const {
    captchaOptions = {},
    secondVerifyWebOptions,
    getDynamicCaptchaConfig,
  } = props;
  const options = {
    commonOptions: {
      ...defaultOptions.commonOptions,
      aid: props.aid,
      did: props.did ? String(props.did) : '0',
      iid: props.iid ? String(props.iid) : '0',
    },
    captchaOptions: {
      ...defaultOptions.captchaOptions,
      sideSlide: props.captchaSideSlide || 'disabled',
      lang: props.language || 'zh',
      showMode: props.captchaShowMode || 'mask',
      region: props.region || 'sg',
      app_name: props.appName || '',
      host: props.captchaHost || '',
      ...captchaOptions,
    },
    secondVerifyWebOptions,
  };

  TTGCaptcha = captchaMap[props.region || 'sg'] || SGCaptcha;

  // for show use dynamic host
  if (getDynamicCaptchaConfig) {
    TTGCaptcha.getDynamicCaptchaConfig = getDynamicCaptchaConfig;
  }

  // umd only has .default
  // https://github.com/rollup/rollup/issues/1156
  if (!TTGCaptcha.init) {
    TTGCaptcha = TTGCaptcha?.default;
  }
  if (props.captchaConfig && typeof TTGCaptcha.config === 'function') {
    TTGCaptcha.config(props.captchaConfig);
  }
  TTGCaptcha.init(
    options,
    () => {},
    () => {}
  );
};

export const sliderView: TypeSliderView = {
  init: (params: any) => {
    const { request, ...props } = params;
    repeatRequest = request;
    initCaptcha(props);
  },
  show: (config: {
    requestConfig: AxiosRequestConfig;
    verifyData: string;
    requestData?: { [key: string]: any };
  }) => {
    const { requestConfig, verifyData, requestData } = config;
    let parsedVerifyData: object = {};
    try {
      parsedVerifyData = JSON.parse(verifyData);
    } catch (e) {
      console.log('wrong desision config!');
    }

    let host: string | undefined = undefined;
    if (TTGCaptcha.getDynamicCaptchaConfig) {
      const urlHost = requestConfig.url?.match(/^https?:\/\/(.*?)\//)?.[0];
      host = TTGCaptcha.getDynamicCaptchaConfig(
        urlHost || requestConfig.baseURL
      );
    }

    let requestDataStr = requestConfig.data || '';
    // rewrite request data
    if (requestData) {
      const originRequestData = stringToObject(requestDataStr);
      requestDataStr = objectToString({
        ...originRequestData,
        ...requestData,
      });
    }

    return new Promise((resolve, reject) => {
      TTGCaptcha.render({
        verify_data: parsedVerifyData,
        captchaOptions: {
          host,
          successCb: async () => {
            sliderView.hasShowed = false;
            const fp = await TTGCaptcha.getFp();
            repeatRequest?.({
              ...requestConfig,
              params: { ...requestConfig.params, fp, isResend: true },
              data: requestDataStr,
            })
              .then(data => {
                resolve(data);
              })
              .catch(err => {
                reject(err);
              });
          },
          closeCb: () => {
            reject('CLOSE_CAPTCHA');
          },
        },
        secondVerifyWebOptions: {
          callBack: async (res: any) => {
            repeatRequest?.({
              ...requestConfig,
              params: {
                ...requestConfig.params,
                isResend: true,
              },
              data: requestDataStr,
            })
              .then(data => {
                resolve(data);
              })
              .catch(err => {
                reject(err);
              });
          },
          closeCallBack: () => {
            reject({ description: 'SECOND_VALID', requestData });
          },
        },
      });
    });
  },
  getFp: () => {
    // 如果已经存在fp，则走缓存
    if (fp) {
      return Promise.resolve(fp);
    }
    const defaultFp: () => Promise<string> = () =>
      new Promise(resolve => {
        setTimeout(() => resolve(''), 1000);
      });
    return Promise.race([defaultFp(), TTGCaptcha.getFp()]).then(
      (fpStr: string) => {
        fp = fpStr;
        console.log('===>', fpStr);
        return fpStr;
      }
    );
  },
};
